export const FETCH_TRANSACTIONS_HISTORY_REQUEST = "FETCH_TRANSACTIONS_HISTORY_REQUEST";
export const FETCH_TRANSACTIONS_HISTORY_SUCCESS = "FETCH_TRANSACTIONS_HISTORY_SUCCESS";
export const FETCH_TRANSACTIONS_HISTORY_FAILURE = "FETCH_TRANSACTIONS_HISTORY_FAILURE";

